module.exports = __webpack_public_path__ + "static/media/fun3.a475332c.png";